@let hotel = hotel$ | async;
<vp-availability-widget
	[accommodationTypes]="accommodationTypes() || hotel?.accommodationTypes"
	[bookingtoolUrl]="bookingtoolUrl"
	[currency]="currency()"
	[dealGuid]="dealGuid()"
	[defaultAdults]="defaultAdults()"
	[forceHideRangePrices]="forceHideRangePrices()"
	[hotelGuid]="hotel?.guid || hotelGuid()"
	[hotelSlug]="hotelSlug()"
	[hotels]="hotels()"
	[hotelsWithOccupancyRestrictions]="hotelsWithOccupancyRestrictions()"
	[initialArrivalDate]="initialArrivalDate()?.toISOString()"
	[initialOccupancy]="initialOccupancy()"
	[language]="language()"
	[maxDate]="effectiveMaxDate()"
	[minDate]="minDate()"
	[occupancyRestrictions]="
		occupancyRestrictions() ||
		hotel?.occupancyRestrictions ||
		hotelStore.occupancyRestrictions?.() ||
		defaultOccupancyRestrictions
	"
	[openAvailabilityInNewTab]="openAvailabilityInNewTab()"
	[packageGuid]="packageGuid()"
	[packages]="packages()"
	[roomGuid]="roomGuid()"
	[showAccommodationTypes]="showAccommodationTypes()"
	[showDates]="showDates()"
	[showHotels]="showHotels()"
	[showOccupancy]="showOccupancy()"
	[showPackages]="showPackages()"
	[showPrices]="showPrices()"
	[stepperConfig]="stepperConfig()"
	[useLocalizedBookingRoute]="true"
	(actionClick)="widgetCTA($event)"
	(packageSelected)="packageSelected.emit($event)"
>
	<ng-content />
</vp-availability-widget>
